import React from 'react';
import { insidePages } from '../data/content';
interface PageFrameProps {
  src: string;
  caption: string;
  width: number;
  height: number;
  isFeatured?: boolean;
}
function PageFrame({
  src,
  caption,
  width,
  height,
  isFeatured = false
}: PageFrameProps) {
  return <figure className="w-full" data-id="element-16" data-mp="2e8ui3qlv1jqg">
      <div className={`overflow-hidden rounded-[14px] border border-brand-charcoal/10 bg-white ${isFeatured ? 'shadow-[0_26px_60px_-30px_rgba(120,84,64,0.35)]' : 'shadow-[0_18px_44px_-28px_rgba(120,84,64,0.3)]'}`} data-id="element-17" data-mp="298oo43s4bl57">
        <img src={src} alt={`${caption} — a real page from The Baby Sleep Bible`} width={width} height={height} loading="lazy" decoding="async" sizes="(min-width: 768px) 34vw, 82vw" className="block h-auto w-full object-contain" data-id="element-18" data-mp="2x5vqllemi1z5" />
      </div>
      <figcaption className="mt-3 text-center font-body text-[11px] uppercase tracking-[0.14em] text-brand-charcoal/45" data-id="element-19" data-mp="3kv6h8a29efzk">
        {caption}
      </figcaption>
    </figure>;
}
export function InsidePages() {
  const [left, center, right] = insidePages;
  return <div className="relative" data-id="element-20" data-mp="1du0wu5xenx7p">
      {/* warm panel behind the composition, for depth */}
      <div aria-hidden="true" className="absolute inset-x-6 bottom-8 top-16 hidden rounded-[20px] bg-brand-oatmeal/60 md:block" data-id="element-21" data-mp="1ds7xlbp4gf9q" />

      {/* Mobile — one page at a time, swipeable */}
      <div className="no-scrollbar -mx-5 flex snap-x snap-mandatory gap-4 overflow-x-auto px-5 pb-2 md:hidden" role="group" aria-label="Pages from The Baby Sleep Bible — swipe to browse" data-id="element-22" data-mp="18uy0razel1bv">
        {insidePages.map(page => <div key={page.src} className="w-[82%] flex-none snap-center" data-id="element-23" data-mp="yxa60l1srttp">
            <PageFrame {...page} data-id="element-24" data-mp="2p8xzwjqfcmy2" />
          </div>)}
      </div>
      <p className="mt-3 text-center font-body text-[11px] uppercase tracking-[0.14em] text-brand-charcoal/40 md:hidden" data-id="element-25" data-mp="2tasvr8pl684g">
        Swipe to see more pages
      </p>

      {/* Desktop — editorial three-page composition */}
      <div className="relative hidden items-center justify-center px-6 py-10 md:flex" data-id="element-26" data-mp="12zfngrh108t">
        <div className="w-[30%] max-w-[300px] translate-y-6" data-id="element-27" data-mp="3t6rzile1egl9">
          <PageFrame {...left} data-id="element-28" data-mp="3t95piftv12ly" />
        </div>
        <div className="relative z-10 -mx-[2.5%] w-[38%] max-w-[400px]" data-id="element-29" data-mp="3o8qdpsp88363">
          <PageFrame {...center} isFeatured data-id="element-30" data-mp="ostpdpghu8ou" />
        </div>
        <div className="w-[30%] max-w-[300px] translate-y-6" data-id="element-31" data-mp="osbnac75h090">
          <PageFrame {...right} data-id="element-32" data-mp="kqq4ybbujtrf" />
        </div>
      </div>
    </div>;
}